//
// # Horizontal / Vertical Direction Enum
//
export type Direction = "horiz" | "vert";
export const Direction = {
  Horiz: "horiz",
  Vert: "vert",
  other,
} as const;

export function other(d: Direction): Direction {
  return d === Direction.Horiz ? Direction.Vert : Direction.Horiz;
}
